import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import './main.css'

createApp(App).mount('#app')
